//Global keys
let locales = {
    "dashboard_menu": "Dashboard",
    "dashboard_menu_programmigEmail": "Programación de correos",
};

//Merge Modules
import list from '../../views/list/lan/es'
import detail from '../../views/detail/lan/es'
import statusChangesHistory from '../../modals/statusChangesHistory/lan/es'
import editNote from '../../modals/editNote/lan/es';
import detailNote from '../../modals/announcementNoteDetail/lan/es';
import listTeam from '../../views/listTeam/lan/es'

locales = {
    ...locales,
    ...list,
    ...detail,
    ...statusChangesHistory,
    ...editNote,
    ...detailNote,
    ...listTeam
};

export default locales;